// extracted by mini-css-extract-plugin
export default {"drawer":"home_drawer__bJy4T","form_input":"home_form_input__kDhBe","otpButton":"home_otpButton__UNMrb","unsubBtn":"home_unsubBtn__b+V5D","historyTable":"home_historyTable__irXZY"};